export default "__VITE_ASSET__q7SCNqcC__"